import React, { useState, useRef, useEffect } from 'react';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal, useIsAuthenticated } from '@azure/msal-react';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { logout, selectData } from '../services/store/userSlice';
import { InputText } from 'primereact/inputtext';
import { confirmDialog } from 'primereact/confirmdialog';
import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';
import { toast } from "react-toastify";
import { Toast } from 'primereact/toast';
import { isSidebarVisible } from "../services/common/states";
import { classNames } from 'primereact/utils';
import { selectUser } from '../services/store/userSlice';
import properties from '../config/environmentProperties';
import { Badge } from "primereact/badge";
import { OverlayPanel } from 'primereact/overlaypanel';
import { notificationService } from "../services/extensions";
import { InputSwitch } from 'primereact/inputswitch';
import { signout } from '../components/sso_login/graph';
import { loginRequest } from "../config/sso_config";
import { attendanceApi, Util } from "../services";
import { date } from 'yup';
import axios from 'axios';
import './App.css';
import { utc } from 'moment';
import moment from "moment";
import appProperties from '../config/appProperties';
import { doAttandence, userProfilePicture } from '../services/common/states';
import { ProtectedSection, hasPermission } from '../components/protected/ProtectedSection';
import { APPLICATION_NOTIFICATION_VIEW, APPLICATION_INOUT_UPDATE, APPLICATION_GLOBAL_SEARCH, TIMESHEET_INVOICE_VIEW, LEAVES_MENU_VIEW } from '../config/permissions';
import { Checkbox } from 'primereact/checkbox';
import { Dialog } from 'primereact/dialog';
import { useFormik } from "formik";
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { InputTextarea } from 'primereact/inputtextarea';
import { userLeaveRecords } from '../services/common/states';
import { workingHours } from "../common/util/constants"
import { regularizationReason } from "../common/util/constants";
import AbsenceRequestDialog from '../pages/leaves/views/absenceRequestDialog';


function AppToolbar({ getLeaves }) {
    const menu = useRef(null);
    const user = useSelector(selectUser);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchText, setSearchText] = useState(null);
    const [menuVisible, setMenuVisible] = useState(true);
    const [checked, setChecked] = useState(false);
    const imgPath = properties.currentEnvironment.docPath + 'images/';
    const op = useRef(null);
    const [idToUpdate, setIdToUpdate] = useState("");
    const [notification, setNotification] = useState([]);
    const { instance, accounts } = useMsal();
    const [ip, setIp] = useState('');
    const [city, setCity] = useState('');
    const [latitude, setLatitude] = useState('');
    const [longitude, setLongitude] = useState('');
    const [checkedBox, setCheckedBox] = useState(false);
    const [showNewForm1, setShowNewForm] = useState(false);
    const [leaveDay, setLeaveDay] = useState([]);
    const [displayBasic, setDisplayBasic] = useState(false);
    const [weekOffCheckedBox, setWeekOffCheckedBox] = useState(false);
    const [compOffCheckedBox, setcompOffCheckedBox] = useState(false);
    const [absenceRequestForm, setAbsenceRequestForm] = useState(false);
    const userLeaveData = useSelector(selectData);
    const [imagePath, setImagePath] = useState("");

    let count = 0;
    useEffect(() => {
        isSidebarVisible.subscribe(v => setMenuVisible(v));
        fetchAttendance();
        getNotification();
        // getLeaveDay();
        generateIp();
        if (count == 0) {
            userLeaveRecords.subscribe((result) => {
                if (result) {
                    // getLeaveDay();
                }
            });
            userProfilePicture.subscribe((result1) => {
                if (result1) {
                    // const imageUrl = imgPath + result1;
                    setImagePath(result1);
                }
            })
            fetchAttendance();
            count++;
        }
    }, []);

    useEffect(() => {
        // getLeaves();
    }, [userLeaveData])



    const getNotification = () => {
        notificationService.getNotification().then(resp => {
            setNotification(resp.data.data);
        });
    };

    const menuClickHandler = (e) => {
        if (e.item) {
            if (e.item.label === 'Logout') {
                dispatch(logout());
                if (properties.currentEnvironment.enableSSO) {
                    ssoLogout();
                }
            } else {
                navigate(e.item.uri);
            }
        }
    }
    const isOnLeave = () => {
        attendanceApi.getIsOnLeaveUpdate().then(resp => {
            setDisplayBasic(false)
        });
    }

    const renderFooter = (name) => {
        return (
            <div>
                <Button label="Yes" icon="pi pi-check" onClick={() => isOnLeave()} autoFocus />
            </div>
        );
    }

    const ssoLogout = () => {
        const logoutRequest = {
            account: instance.getAccountByHomeId(accounts[0].homeAccountId),
            mainWindowRedirectUri: properties.currentEnvironment.redirectUrl,
            postLogoutRedirectUri: properties.currentEnvironment.redirectUrl,
        };
        instance.logoutPopup(logoutRequest);
    }
    var currentUser = JSON.parse(localStorage.getItem("user"));

    const items = [
        { label: 'Profile', icon: 'pi pi-user', uri: '/profile', command: menuClickHandler },
        { label: 'My Project', icon: 'pi pi-book', uri: '/my-project', command: menuClickHandler },
        { label: 'My Teams', icon: 'pi pi-users', uri: '/team', command: menuClickHandler },
        // { label: 'Training', icon: 'pi pi-desktop', uri: '/training', command: menuClickHandler },
        { label: 'Logout', icon: 'pi pi-sign-out', command: menuClickHandler }
    ];

    if (currentUser?.roles[0] === "employee") {
        items.splice(1, 2);
    }

    const profileDrawerClicked = (e) => {
        menu.current.toggle(e)
    }

    const mnuClickHandler = (e) => {
        isSidebarVisible.next(!menuVisible);
    }

    const fetchAttendance = (e) => {
        attendanceApi.getAllAttendance().then((resp) => {
            try {
                const reqData = resp.data.data[0];
                doAttandence.next(resp.data.data);
                let timeSinceIn = (Math.abs((new Date(Util.currentTimeInUtc()) - new Date(reqData.inTime)) / 3600000))
                if (!reqData.outTime) {
                    setIdToUpdate(reqData)
                    setChecked(true)
                    if ((reqData.outTime) || (!reqData.outTime && timeSinceIn > appProperties.maxInTime)) {
                        setChecked(false)
                    }
                }

                //use for hide and show checkbox in right of out and In button 
                let isOnLeavDeta = resp.data.data.map((i) => i.isOnLeave)
                if (isOnLeavDeta.includes(true) === true) {
                    return setDisplayBasic(true);
                }
            } catch (error) {
                // Error handle
            }
        });
    };

    const generateIp = async () => {
        const res = await axios.get('https://geolocation-db.com/json/')
        setIp(res.data.IPv4);
        navigator.geolocation.getCurrentPosition(pos => {
            const { latitude, longitude } = pos.coords;
            setLatitude(latitude);
            setLongitude(longitude);
            const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`;
            fetch(url).then(res => res.json()).then(data =>
                setCity(data.address.city + " " + data.address.state))
        })
    }

    const createAttendance = (e, param) => {
        console.log(e, "createAttendance")
        setChecked(e.value);
        const reject = () => {
            setChecked(true);
        }

        const markAttendence = (obj) => {
            console.log(obj, "markAttendence")
            attendanceApi.createAttendance(obj).then(resp => {
                console.log(resp, "resprespresp")
                if (resp.data.error) {
                    regularizationConfirmation(resp.data.error);
                    setChecked(!e.value);
                } else {
                    try {
                        if (resp.data.leaveDay && resp.data.leaveDay.length > 0) {
                            setLeaveDay(resp?.data?.leaveDay);
                            confirm1(resp?.data?.leaveDay[0]);
                        } else {
                            fetchAttendance();
                            toast.info(resp.data.message);
                        }
                    } catch (error) {
                        console.log(error, "Error on leave day");
                    }
                }
            });
        }

        //popup when user work from home or office
        const confirm3 = () => {
            confirmDialog({
                message: 'Are you working from office or home?',
                header: 'Confirmation',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Office',
                rejectLabel: 'Home',
                accept: () => {
                    let obj = {
                        ip: ip,
                        location: "WFO",
                        date: moment().format('YYYY-MM-DD'),
                        inTime: new Date(),
                    }
                    markAttendence(obj);

                },
                reject: () => {
                    let obj = {
                        ip: ip,
                        location: "WFH",
                        date: moment().format('YYYY-MM-DD'),
                        inTime: new Date(),
                    }
                    markAttendence(obj);
                },
                onHide: setChecked(false)
            });
        };
        //popup for markout
        const confirm2 = () => {
            confirmDialog({
                message: 'Do you wish to Mark OUT?',
                header: 'OUT Confirmation',
                icon: 'pi pi-info-circle',
                acceptClassName: 'p-button-danger',
                acceptLabel: 'Yes',
                rejectLabel: 'No',
                accept: () => {
                    let obj = {
                        id: idToUpdate.id,
                        outDate: moment().format('YYYY-MM-DD'),
                        outTime: new Date(),
                        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                    }
                    attendanceApi.updateAttendanceById(obj).then((resp) => {
                        try {
                            fetchAttendance();
                            if (resp.data.success) {
                                toast.info("Marked Out Successfully");
                            } else {
                                toast.error(resp.data.error);
                            }
                            setChecked(false);
                        } catch (error) {
                            // Error handle
                        }
                    });
                },
                reject: () => {
                    setChecked(true)
                },
                onHide: reject
            });
        };

        //popup for are you on leave
        const confirm1 = (leaveDate) => {
            confirmDialog({
                message: (
                    <p>
                        Were you on leave on <strong style={{ color: 'red' }}>{leaveDate}</strong>?
                        <br /><br />
                        Click <strong style={{ color: 'green' }}>YES</strong> if you were on personal or approved leave.
                        <br />
                        Click <strong style={{ color: 'red' }}>NO</strong> if it was a Client Holiday, Week Off, or Comp Off. Please raise a regularization request with your manager.
                    </p>
                ),
                header: 'Confirmation',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Yes',
                rejectLabel: 'No',
                accept: () => {
                    try {
                        if (hasPermission(LEAVES_MENU_VIEW)) {
                            lmsForm(leaveDate);
                        } else {
                            const date = new Date(leaveDate);
                            console.log(date, "Confirm1().accept().date")
                            // // Set the time to "00:00:00"
                            date.setHours(0);
                            date.setMinutes(0);
                            date.setSeconds(0);
                            let obj = {
                                date: Util.dateConverterForAttendance(date),
                                outDate: Util.dateConverterForAttendance(date),
                                inTime: date,
                                outTime: date,
                                comments: 'Leave',
                                location: 'LH',
                                isOnLeave: true,
                            };
                            attendanceApi.createAttendanceRequest(obj).then(resp => {
                                if (resp.data.success === true) {
                                    // getLeaveDay()
                                    toast.success("Leave applied on ESS for " + leaveDate + ". Please apply on LMS")
                                    setDisplayBasic(true);
                                    fetchAttendance();
                                }
                                else {
                                    toast.error(resp.data.error);
                                }
                            });
                        }

                    } catch (error) {
                        console.log(error, "Error on confirm dialog")
                    }
                },

                reject: () => {
                    attendanceForm()
                },
                onHide: setChecked(false)
            });
        };

        // Popup for manager regularization
        const regularizationConfirmation = (regMsg) => {
            confirmDialog({
                message: regMsg,
                header: 'Confirmation',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Yes',
                rejectLabel: 'No',
                accept: () => acceptFunc(),
                // accept: () => {},
                reject: () => { },
                // onHide: setChecked(false)
            });
        };

        const acceptFunc = () => {
            navigate('/attendance?action=reg');
        };


        if (e.value) {
            confirm3()
        }
        if (!e.value && !idToUpdate.outTime) {
            confirm2();
        }
    };

    const lmsForm = (ld) => {
        try {
            let attendanceDate = { leaveDay: ld, leaveDays: ld }
            localStorage.setItem("absenceData", JSON.stringify(attendanceDate));
            setTimeout(() => {
                navigate("/leaves/new-absence");
            }, 2000)
            navigate("/leaves");
        } catch (error) {
            localStorage.removeItem("absenceData")
        }
    };

    const attendanceForm = () => {
        setShowNewForm(true);
    };
    const officeOrHome = [
        { label: 'Office', code: 'WFO' },
        { label: 'Home', code: 'WFH' },
    ]
    const yourDropdownOptionsArray = [
        { label: regularizationReason.MARKOUT_FORGOT, value: regularizationReason.MARKOUT_FORGOT },
        { label: regularizationReason.REFILL_ATTENDANCE, value: regularizationReason.REFILL_ATTENDANCE },
        // Add more options as needed
    ];

    const useWindowDimensions = () => {
        const hasWindow = typeof window !== "undefined"
        function getWindowDimensions() {
            const width = hasWindow ? window.innerWidth : null
            const height = hasWindow ? window.innerHeight : null
            return {
                width,
                height,
            }
        }

        const [windowDimensions, setWindowDimensions] = useState(
            getWindowDimensions()
        )

        useEffect(() => {
            if (hasWindow) {
                function handleResize() {
                    setWindowDimensions(getWindowDimensions())
                }
                window.addEventListener("resize", handleResize)
                return () => window.removeEventListener("resize", handleResize)
            }
        }, [hasWindow])
        return windowDimensions
    }

    const { height, width } = useWindowDimensions()
    const breakpoint = 1000

    const clickedNotification = () => {
        op.current.hide();
        navigate('/notification-bar')
    }
    const formik = useFormik({
        initialValues: {
            inTime: '',
            outTime: '',
            date: null,
            reason: null,
            attachment: null,
            location: ''
        },
        validate: (data) => {
            let errors = {};
            if (!checkedBox && !weekOffCheckedBox && !compOffCheckedBox) {
                if (!data.inTime) {
                    errors.inTime = 'In Time is required.';
                }

                if (!data.outTime) {
                    errors.outTime = 'Out Time is required.';
                }

                if (!data.reason) {
                    errors.reason = 'Reason is required';
                }
                if (!data.location) {
                    errors.location = 'Location is required';
                }
            }

            return errors;
        },
        onSubmit: (data) => {
            data.date = leaveDay[0];
            createMissingAttendance(data);
        }
    });
    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };
    const createMissingAttendance = (data) => {
        const date = new Date(data.date);
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        let reqDate = Util.dateConverterForAttendance(data.date);
        let reqInTime = Util.getTimeWithTimezone(data.inTime);
        let reqOutTime = Util.getTimeWithTimezone(data.outTime);
        let obj = {
            date: Util.dateConverterForAttendance(data.date),
            outDate: Util.dateConverterForAttendance(data.date),
            inTime: weekOffCheckedBox ? date : checkedBox ? date : compOffCheckedBox ? date : Util.convertTZ(reqDate, reqInTime),
            outTime: weekOffCheckedBox ? date : checkedBox ? date : compOffCheckedBox ? date : Util.convertTZ(reqDate, reqOutTime),
            reason: weekOffCheckedBox ? 'Week Off' : checkedBox ? 'Client Holiday' : compOffCheckedBox ? 'Comp Off' : data.reason,
            innTime: Util.convertTZ(reqDate, reqInTime),
            outtTime: Util.convertTZ(reqDate, reqOutTime),
            location: weekOffCheckedBox ? 'WO' : checkedBox ? 'CH' : compOffCheckedBox ? 'CO' : data.location.code,
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            isClientHoliday: checkedBox ? true : false,
            isWeekOff: weekOffCheckedBox ? true : false,
            isRegularize: checkedBox ? false : true,
            isCompOff: compOffCheckedBox ? true : false

        };
        const workingTimeCalcDiff = Util.attendanceHrdDiff(obj.inTime, obj.outTime);
        if (Util.convertHoursIntoMin(workingTimeCalcDiff) > Util.convertHoursIntoMin(workingHours.HOURS)) {
            toast.error("Working hrs should not greater than 14:00 hrs!")
        } else {
            console.log(obj, "objobjobj")
            attendanceApi.createAttendanceRequest(obj).then(resp => {
                if (resp.data.success === true) {
                    toast.success(resp.data.message)
                    // getLeaveDay()
                } else {
                    toast.error(resp.data.error)
                }
                setShowNewForm(false);
                // closeForm();
            });
        }
    }
    const changeHolidayCheckbox = (e) => {
        formik.setFieldValue('inTime', '');
        formik.setFieldValue('outTime', '');
        setCheckedBox(e.checked);
    }
    const changeWeekOffCheckbox = (e) => {
        formik.setFieldValue('inTime', '');
        formik.setFieldValue('outTime', '');
        setWeekOffCheckedBox(e.checked);
    }
    const changeCompOffCheckbox = (e) => {
        formik.setFieldValue('inTime', '');
        formik.setFieldValue('outTime', '');
        setcompOffCheckedBox(e.checked)
    }
    if (Object.keys(imagePath).length === 0) {
    } else {
    }
    return (
        <div>
            {width <= breakpoint ? (
                <div className={classNames('grid', menuVisible ? 'app-toolbar1' : 'app-toolbar1-wm')}>
                    <Toast ref={toast}></Toast>
                    <Menu model={items} popup ref={menu} id="popup_menu" />
                    {/* <div className='col-2' style={{ width: '100px' }}>
                    </div> */}
                    {/* <div className='col-12' style={{ textAlign: 'right' }}>
                        <ul className='menu-item-list'>
                            <li>
                                <div id="fadeshow1">
                                    <li style={{ paddingTop: '15px' }}><span><b>OUT</b></span></li>
                                    <li style={{ paddingTop: '15px' }}><InputSwitch className="p-inputswitch" checked={checked} onChange={(e) => createAttendance(e)} /></li>
                                    <li style={{ paddingTop: '15px', paddingRight: '25px' }}><span style={{}}><b>IN</b></span></li>
                                </div>
                                <Badge
                                    value={notification.length}
                                    style={{ position: "fixed", height: '20px', width: '23px' }}>
                                </Badge>
                                <Button
                                    icon="pi pi-bell"
                                    className="p-button-rounded p-button-text mr-3 mb-2 p-overlay-badge"
                                    onClick={(e) => op.current.toggle(e)}
                                    aria-haspopup
                                    aria-controls="overlay_panel" />
                            </li>
                            <OverlayPanel
                                ref={op}
                                id="overlay_panel"
                                style={{ width: '300px' }}
                                className="overlaypanel-demo">

                                <h2 style={{ color: 'black', fontSize: '16px' }} className='mt-0'>Notifications</h2>

                                {notification.slice(0, 4).map((item, index) =>
                                    <div key={'an-' + index} className='notification-wrapper'>
                                        <a href="#" style={{ textDecoration: 'none' }} onClick={clickedNotification}>
                                            <React.Fragment>
                                                <div className='grid'>
                                                    <div className='col-12'>
                                                        <div style={{ color: 'black', fontWeight: 'bolder' }}>{item.title}</div>
                                                        <div style={{ color: 'black' }}>{item.description}</div>
                                                        <div style={{ color: 'rgb(128,128,128)' }}>{Util.dateConverterUS(item.createdAt, true)}</div>
                                                    </div>
                                                </div>
                                            </React.Fragment>
                                        </a>
                                    </div>
                                )}
                                <a href="#" style={{ textDecoration: 'none', marginLeft: "110px", textAlign: "center", fontWeight: 'bolder' }} onClick={clickedNotification}>
                                    View All
                                </a>
                            </OverlayPanel>
                            <li>
                                <a href='#' id="menu-link" className="profile-btn" onClick={profileDrawerClicked}>
                                    <p>
                                        <strong>{user?.firstName || 'Guest'} {user?.lastName || ''}</strong>
                                        <small style={{ fontSize: '8px' }}>{user.email || ''}</small>
                                    </p>
                                    <span>
                                        {user.photo === "" || user.photo === null ? <span className='profile-image'>{user.firstName.substr(0, 1)}
                                            {user.lastName.substr(0, 1)}</span> : <img src={Object.keys(imagePath).length === 0 ? imgPath + user?.photo : imgPath + imagePath || ''} alt='' className='profile-image' />}
                                    </span>
                                </a>
                            </li>
                        </ul>
                    </div> */}
                    <div className='col-12' style={{ textAlign: 'right' }}>
                        <ul className='menu-item-list'>
                            {/* <li>
                                <ProtectedSection permissions={[APPLICATION_INOUT_UPDATE]}>
                                    {/* <Checkbox style={{ bottom: '15px' }} placeholder="Top" tooltip="Please apply leave on LMS or Send request for regularization" tooltipOptions={{ position: 'top' }} onChange={e => setCheckedBox(e.checked)} checked={checkedBox}></Checkbox> */}
                                    {/* <li style={{ paddingTop: '15px' }}><span><b>OUT</b></span></li>
                                    <li style={{ paddingTop: '15px' }}><InputSwitch className="p-inputswitch" checked={checked} onChange={(e) => createAttendance(e)} /></li>
                                    <li style={{ paddingTop: '15px', paddingRight: '25px' }}><span style={{}}><b>IN</b></span></li>
                                </ProtectedSection> */}
                                {/* <ProtectedSection permissions={[APPLICATION_NOTIFICATION_VIEW]}>
                                    <Badge
                                        value={notification.length}
                                        style={{ position: "fixed", height: '20px', width: '23px' }}>
                                    </Badge>
                                    <Button
                                        icon="pi pi-bell"
                                        className="p-button-rounded p-button-text mr-3 mb-2 p-overlay-badge"
                                        onClick={(e) => op.current.toggle(e)}
                                        aria-haspopup */}
                            {/* //             aria-controls="overlay_panel" />
                            //     </ProtectedSection>

                            // </li> */}
                            <OverlayPanel
                                ref={op}
                                id="overlay_panel"
                                disable={notification.length > 0}
                                style={{ width: '300px' }}
                                className="overlaypanel-demo">

                                <h2 style={{ color: 'black', fontSize: '16px' }} className='mt-0'>Notifications</h2>

                                {notification.slice(0, 4).map((item, index) =>
                                    <div key={'n1-' + index} className='notification-wrapper'>
                                        <a href="#" style={{ textDecoration: 'none' }} onClick={clickedNotification}>
                                            <React.Fragment>
                                                <div className='grid'>
                                                    <div className='col-12'>
                                                        <div style={{ color: 'black', fontWeight: 'bolder' }}>{item.title}</div>
                                                        <div style={{ color: 'black' }}>{item.description}</div>
                                                        <div style={{ color: 'rgb(128,128,128)' }}>{Util.dateConverterUS(item.createdAt, true)}</div>
                                                    </div>
                                                </div>
                                            </React.Fragment>
                                        </a>
                                    </div>
                                )}
                                <a href="#" style={{ textDecoration: 'none', marginLeft: "110px", textAlign: "center", fontWeight: 'bolder' }} onClick={clickedNotification}>
                                    View All
                                </a>
                            </OverlayPanel>
                            <li>
                                <a href='#' id="menu-link" className="profile-btn" onClick={profileDrawerClicked}>
                                    <p>
                                        <strong>{user.firstName.substr(0, 70) || 'Guest'} {user.lastName.substr(0, 70) || ''}</strong>
                                        <small>{user.email || ''}</small>
                                    </p>
                                    <span>
                                        {user.photo === "" || user.photo === null ? <>
                                            <img src={'/assets/images/avtar.png'} alt='' className='profile-image' onError={(e) => e.target.src = '/assets/images/avtar.png'} />
                                        </> : <><img src={imgPath + user?.photo || ''} alt='' className='profile-image' onError={(e) => e.target.src = '/assets/images/avtar.png'} /></>}
                                    </span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

            ) : (

                <div className={classNames('grid', menuVisible ? 'app-toolbar' : 'app-toolbar-wm')}>
                    <Toast ref={toast}></Toast>
                    <Menu model={items} popup ref={menu} id="popup_menu" />
                    {/* <div className='col-5'> */}
                        <ProtectedSection permissions={[APPLICATION_GLOBAL_SEARCH]}>
                            <Button icon="pi pi-align-justify" className="p-button-rounded p-button-text mr-3" onClick={mnuClickHandler} />
                            <span className="p-input-icon-left">
                                <i className="pi pi-search" />
                                <InputText value={searchText} onChange={(e) => setSearchText(e.target.value)} placeholder="Search" />
                            </span>
                        </ProtectedSection>
                        {/* <div className='ess-in' style={{ display: (checked ? 'block' : 'none') }}>
                            <span className='icon'><img src='/assets/images/In.svg' /></span>
                            <strong>Logged Hours: </strong>
                            <em>10:30:35</em>
                        </div> */}
                    {/* </div> */}
                    <div className='col-12' style={{ textAlign: 'right' }}>
                        <ul className='menu-item-list'>
                            <li>
                                <ProtectedSection permissions={[APPLICATION_INOUT_UPDATE]}>
                                    {/* <Checkbox style={{ bottom: '15px' }} placeholder="Top" tooltip="Please apply leave on LMS or Send request for regularization" tooltipOptions={{ position: 'top' }} onChange={e => setCheckedBox(e.checked)} checked={checkedBox}></Checkbox> */}
                                    <li style={{ paddingTop: '15px' }}><span><b>OUT</b></span></li>
                                    <li style={{ paddingTop: '15px' }}><InputSwitch className="p-inputswitch" checked={checked} onChange={(e) => createAttendance(e)} /></li>
                                    <li style={{ paddingTop: '15px', paddingRight: '25px' }}><span style={{}}><b>IN</b></span></li>
                                </ProtectedSection>
                                <ProtectedSection permissions={[APPLICATION_NOTIFICATION_VIEW]}>
                                    <Badge
                                        value={notification?.length}
                                        style={{ position: "fixed", height: '20px', width: '23px' }}>
                                    </Badge>
                                    <Button
                                        icon="pi pi-bell"
                                        className="p-button-rounded p-button-text mr-3 mb-2 p-overlay-badge"
                                        onClick={(e) => op.current.toggle(e)}
                                        aria-haspopup
                                        aria-controls="overlay_panel" />
                                </ProtectedSection>

                            </li>
                            <OverlayPanel
                                ref={op}
                                id="overlay_panel"
                                disable={notification?.length > 0}
                                style={{ width: '300px' }}
                                className="overlaypanel-demo">

                                <h2 style={{ color: 'black', fontSize: '16px' }} className='mt-0'>Notifications</h2>

                                {notification?.slice(0, 4).map((item, index) =>
                                    <div key={'n1-' + index} className='notification-wrapper'>
                                        <a href="#" style={{ textDecoration: 'none' }} onClick={clickedNotification}>
                                            <React.Fragment>
                                                <div className='grid'>
                                                    <div className='col-12'>
                                                        <div style={{ color: 'black', fontWeight: 'bolder' }}>{item.title}</div>
                                                        <div style={{ color: 'black' }}>{item.description}</div>
                                                        <div style={{ color: 'rgb(128,128,128)' }}>{Util.dateConverterUS(item.createdAt, true)}</div>
                                                    </div>
                                                </div>
                                            </React.Fragment>
                                        </a>
                                    </div>
                                )}
                                <a href="#" style={{ textDecoration: 'none', marginLeft: "110px", textAlign: "center", fontWeight: 'bolder' }} onClick={clickedNotification}>
                                    View All
                                </a>
                            </OverlayPanel>
                            <li>
                                <a href='#' id="menu-link" className="profile-btn" onClick={profileDrawerClicked}>
                                    <p>
                                        <strong>{user.firstName.substr(0, 70) || 'Guest'} {user.lastName.substr(0, 70) || ''}</strong>
                                        <small>{user.email || ''}</small>
                                    </p>
                                    <span>
                                        {user.photo === "" || user.photo === null ? <>
                                            <img src={'/assets/images/avtar.png'} alt='' className='profile-image' onError={(e) => e.target.src = '/assets/images/avtar.png'} />
                                        </> : <><img src={imgPath + user?.photo || ''} alt='' className='profile-image' onError={(e) => e.target.src = '/assets/images/avtar.png'} /></>}
                                    </span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            )
            }
            <Dialog
                header={"Request for Regularization " + leaveDay[0]}  //{leaveDay[0]}
                visible={showNewForm1}
                style={{ width: '35vw' }}
                onHide={() => setShowNewForm(false)}
            >
                <form onSubmit={formik.handleSubmit} className="p-fluid p-grid mt-2">
                    <div className='mb-3 checkbox_block'>
                        <span className='regular_checkbox'>
                            <Checkbox
                                id="leave"
                                name=""
                                onChange={e => changeHolidayCheckbox(e)} checked={checkedBox}
                                disabled={weekOffCheckedBox || compOffCheckedBox}
                            />
                            <span style={{ marginLeft: '5px' }}>Client Holiday</span>
                        </span>
                        <span className="regular_checkbox">
                            <Checkbox
                                id="leave"
                                name=""
                                onChange={e => changeWeekOffCheckbox(e)} checked={weekOffCheckedBox}
                                disabled={checkedBox || compOffCheckedBox}
                            />
                            <span style={{ marginLeft: '5px' }}>Week Off</span>
                        </span>
                        <span className="regular_checkbox">
                            <Checkbox
                                id="leave"
                                name=""
                                onChange={e => changeCompOffCheckbox(e)} checked={compOffCheckedBox}
                                disabled={checkedBox || weekOffCheckedBox}
                            />
                            <span style={{ marginLeft: '5px' }}>Comp Off</span>
                        </span>
                    </div>
                    <div className="grid mt-1">
                        <div className="p-field col-6">
                            <label htmlFor="date">Location</label>
                            <span>
                                <Dropdown
                                    options={officeOrHome}
                                    name="location"
                                    disabled={checkedBox || weekOffCheckedBox || compOffCheckedBox}
                                    value={formik.values.location}
                                    onChange={formik.handleChange}
                                    placeholder="Select your Location" />
                            </span>

                            {getFormErrorMessage('location')}
                        </div>
                    </div>
                    <div className="grid mt-1">
                        <div className="p-field col-6">
                            <span>
                                <label htmlFor="inTime">In Time</label>
                                <Calendar
                                    keyfilter="time"
                                    id="inTime"
                                    name="inTime"
                                    value={formik.values.inTime}
                                    timeOnly hourFormat="24"
                                    showSeconds
                                    disabled={checkedBox || weekOffCheckedBox || compOffCheckedBox}
                                    maxDate={new Date(formik.values.outTime)}
                                    onChange={formik.handleChange}
                                />
                            </span>
                            {getFormErrorMessage('inTime')}
                        </div>

                        <div className="p-field col-6">
                            <span>
                                <label htmlFor="outTime">Out Time</label>
                                <Calendar
                                    keyfilter="int"
                                    id="outTime"
                                    name="outTime"
                                    value={formik.values.outTime}
                                    timeOnly hourFormat="24"
                                    disabled={checkedBox || weekOffCheckedBox || compOffCheckedBox}
                                    showSeconds
                                    minDate={new Date(formik.values.inTime)}
                                    onChange={formik.handleChange}
                                />
                            </span>
                            {getFormErrorMessage('outTime')}
                        </div>
                    </div>
                    <div className="p-field">
                        <span>
                            <label htmlFor="reason">Reason</label>
                            <Dropdown
                                id="reason"
                                name="reason"
                                disabled={checkedBox || weekOffCheckedBox || compOffCheckedBox}
                                value={formik.values.reason}
                                options={yourDropdownOptionsArray}
                                onChange={formik.handleChange}
                                className={classNames({ "p-invalid": isFormFieldValid("reason") })}
                                placeholder="Select a reason"
                            />
                        </span>
                        {getFormErrorMessage('reason')}
                    </div>
                    <div className='pt-3'>
                        <div className='text-right'>
                            <div>
                                <Button
                                    type="button"
                                    label="Cancel"
                                    className="p-button-rounded p-default mr-2"
                                    onClick={() => setShowNewForm(false)} 
                                />
                                <Button
                                    type="submit"
                                    label="Submit"
                                    className="p-button-rounded"
                                />
                            </div>
                        </div>
                    </div>
                </form>
            </Dialog>
            <Dialog header="LMS Apply" visible={displayBasic} style={{ width: '250px' }} footer={renderFooter('displayBasic')}>
                <p className="pi pi-info" style={{ fontSize: "16px" }}> Kindly apply leave on LMS, and click YES. </p>
            </Dialog>
        </div>
    )
};

export default AppToolbar;